'use strict';

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React, { Component } from 'react';
import Layout from 'Layouts/Front';
import BookingInfosCard from 'Components/Front/BookingInfosCard';
import PaymentSuccess from 'Components/Front/PaymentSuccess';
import Loader from 'Pure/Loader';
import resetStorageBookingValues from 'Functions/resetStorageBookingValues';
import ajaxRequest from 'Functions/ajax/ajaxRequest';
import { action } from 'Shared/Routes';
export default class LibConfirmationPage extends Component {
  state = {
    loading: false,
    status_messages: {}
  };
  componentDidMount() {
    const component = this,
      props = this.props,
      state = this.state;
    resetStorageBookingValues();
    component.fetchBooking();
  }
  fetchBooking = async () => {
    const component = this,
      props = this.props,
      state = this.state;
    component.setState({
      loading: true
    });
    try {
      var response = await ajaxRequest(action('GetSessionBooking'));
    } catch (update) {
      return component.setState(update);
    }
    component.setState({
      booking: response.booking,
      loading: false
    });
  };
  render() {
    const component = this,
      props = this.props,
      state = this.state;
    const loader = state.loading === true ? /*#__PURE__*/React.createElement(Loader, {
      className: "c-loader",
      bemit: ['white', 'bg-carbon']
    }) : undefined;
    const infos = state.booking?.id ? /*#__PURE__*/React.createElement("div", {
      className: "booking-confirmation-container__infos"
    }, /*#__PURE__*/React.createElement(BookingInfosCard, {
      booking: state.booking,
      "discount-code": state.booking.discount_code
    })) : undefined;
    const output = /*#__PURE__*/React.createElement(Layout, _extends({}, props, {
      "hide-navbar": true,
      "header-bemit": ['inline']
    }), /*#__PURE__*/React.createElement("div", {
      className: "page-container"
    }, /*#__PURE__*/React.createElement("div", {
      className: "booking-confirmation-container"
    }, /*#__PURE__*/React.createElement("div", {
      className: "booking-confirmation-container__content"
    }, /*#__PURE__*/React.createElement(PaymentSuccess, {
      free: state.booking?.amount > 0 === false
    })), infos), loader));
    return output;
  }
}
